import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    mediaDataListLoading: false,
    mediaDataListSuccess: null,
    mediaDataListError: '',
}

export const samplePaperSlice = createSlice({
    name: 'samplePaper',
    initialState,
    reducers: {

        setMediaDataListLoading: (state) => {
            state.mediaDataListLoading = true;
            state.mediaDataListSuccess = null;
            state.mediaDataListError = '';
        },
        setMediaDataListSuccess: (state, action) => {
            state.mediaDataListLoading = false;
            state.mediaDataListSuccess = action.payload;
            state.mediaDataListError = '';
        },
        setMediaDataListError: (state, action) => {
            state.mediaDataListLoading = false;
            state.mediaDataListSuccess = null;
            state.mediaDataListError = action.payload;
        },
    },
})

// Action creators are generated for each case reducer function
export const { setMediaDataListLoading, setMediaDataListSuccess, setMediaDataListError } = samplePaperSlice.actions

export default samplePaperSlice.reducer;